// extracted by mini-css-extract-plugin
export var chat = "styles-module--chat--3edfa";
export var container = "styles-module--container--d7f58";
export var contentContainer = "styles-module--contentContainer--a67b1";
export var contrastOverlay = "styles-module--contrastOverlay--947d1";
export var desktop = "1340px";
export var faceText = "styles-module--faceText--4f59b";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var text = "styles-module--text--a0fa9";